import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Formulario from './Formulario';
import reportWebVitals from './reportWebVitals';

import {
  BrowserRouter as Router, Route, Routes
} from "react-router-dom";

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<Formulario />} />
      </Routes>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
